<div class="boolean-cell-content">
  @if (valueSg() === true) {
    <i class="atn-icon atn-check-circle"></i>
  } @else if (valueSg() === false) {
    <i class="atn-icon atn-close-circle"></i>
  }
</div>
